// extracted by mini-css-extract-plugin
export default {"root":"f9C2pPBfP2wQRo_mRMRp","content":"LSQVcoUbk4cGJgAFZiAV","list":"fyu3afZdvvgLJZ77hMLo","listItem":"GPubdoWvHzYpcl3Cs7q2"};